module.exports = __webpack_public_path__ + "static/media/decidel.46215c76.png";